import { useQuery } from "react-query";
import { getBrandNotes } from "ui-io/queries/configs/get-brand-notes";
import { NonIdealState } from "@blueprintjs/core/lib/esm/components";

import TableLoading from "../table-loading";
import CompanyNotesList from "./notes-list";
import { ErrorState } from "ui-components";

const EmptyDataMessage = () => (
  <NonIdealState
    icon="book"
    title="No data available"
    description="Could not find brand notes for this Brand"
  />
);
const CompanyNotes = ({
  companyID,
}: {
  companyID?: string;
}) => {
  const companyNotes = useQuery(getBrandNotes({ companyID:companyID || "" }));
  switch (companyNotes.status) {
    case "loading":
      return <TableLoading />;
    case "error":
      return <ErrorState error={companyNotes.error} />;
    case "success":
      return !!companyNotes.data.length ? (
        <CompanyNotesList notes={companyNotes.data} />
      ) : (
        <EmptyDataMessage />
      );
    default:
      return <EmptyDataMessage />;
  }
};
export default CompanyNotes;
